module.exports = __webpack_public_path__ + "img/file-earmark-arrow-down-fill.a9546cbb.svg";